export default __webpack_public_path__ + "static/media/square-right.b5edc335.svg";